class Constants {
    constructor() {
        this.TenantSep = "__<<>>__";
    }
}
export const AppConstants = new Constants();
